import PacsHero from "./pacsHero/PacsHero"
import PacsPartners from "./PacsPartners/PacsPartners"
import PacsOffers from "./PacsOffers/PacsOffers"
import PacsDiscount from "./PacsDiscount/PacsDiscount"
import PacsQuestions from "./PacsQuestions/PacsQuestions"

export { PacsHero, PacsPartners, PacsOffers, PacsDiscount, PacsQuestions }
